export default __webpack_public_path__ + "images/133c12a2d2b9f7df4c5a80583da85287-football.webp";